import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const Hero = () => {
 
  const ref = useRef(null);

  const isInView = useInView(ref, {
    once: false,
    amount: 0.3,
    margin: "-100px 0px",
  });

  const containerVariants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const textContainerVariants = {
    initial: {
      opacity: 0,
    },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const textVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      ref={ref}
      className="flex flex-col items-center justify-center min-h-[60vh] py-2 px-4"
      variants={containerVariants}
      initial="initial"
      animate={isInView ? "animate" : "initial"}
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.h3
          className="text-2xl md:text-3xl lg:text-4xl leading-relaxed md:leading-relaxed font-medium text-gray-800 mb-16"
          variants={textContainerVariants}
        >
          <motion.div variants={textVariants}>
            At Mentorhub we turbocharge your data engineering journey,{" "}
            <span className="text-[#F5A404]">learn from seasoned pros</span>,
            get 1:1 mentorship with{" "}
            <span className="text-[#F1375A]">insider interview</span>{" "}
            <span className="text-[#1B3673]">tips</span>, and{" "}
            <span className="text-[#F5A404]">build real-world projects</span>{" "}
            that pop on your resume. Our{" "}
            <span className="text-[#F1375A]">cutting-edge curriculum</span>,
            covering advanced SQL, Python, and cloud architecture, gives you the
            skills <span className="text-[#1B3673]">employers crave</span>.
          </motion.div>
        </motion.h3>

        <motion.div variants={textContainerVariants} className="space-y-8">
          <motion.h2
            variants={textVariants}
            className="text-4xl md:text-5xl font-bold"
          >
            Why <span className="text-[#1B3673]">Mentorhub</span>
          </motion.h2>

          <motion.p
            variants={textVariants}
            className="text-xl md:text-2xl text-gray-600"
          >
            At Mentorhub, we believe your success is our mission. We're not just
            another learning platform, we're your career accelerator. Our
            seasoned data engineering pros deliver real-world, practical skills
            through
          </motion.p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Hero;
